import React, { useState } from "react";


import MainModal from "./MainModal";
import { DayPickerRangeController } from "react-dates";
import Button from "../button/Button";
import "../../styles/job/service-date.css";


const SelectDateModal = ({ isVisible, onClose, saveDate, selectedDate_ }) => {


    const [selectedDate, setSelectedDate] = useState(selectedDate_);
    const [loading, setLoading] = useState(selectedDate_);
    const [focused, setFocused] = useState("startDate");

    const filterDate = startDate => {
        setSelectedDate(startDate.utc().set('hour', 12));
    };

    const onFocusChangeDate = focusedInput => {
        // Force the focusedInput to always be truthy so that dates are always selectable
        setFocused(!focusedInput ? "startDate" : focusedInput);
    };

    const handleSaveDate = () => {
        setLoading(true);
        saveDate(new Date(selectedDate.format()));
    };

    

    return (
        <MainModal
            gigant={true}
            title={"Selecciona una fecha"}
            subtitle={
                "Selecciona la fecha de caducidad para la subscripcion del pro a ProManager"
            }
            isVisible={isVisible}
            onClose={onClose}
            style={{width:"30%"}}
        >
                <DayPickerRangeController
                    style={{margin:"auto"}}
                    onDatesChange={({ startDate }) => filterDate(startDate)}
                    onFocusChange={onFocusChangeDate}
                    focusedInput={focused}
                    startDate={selectedDate}
                    endDate={selectedDate}
                    numberOfMonths={1}
                    hideKeyboardShortcutsPanel={true}
                    isOutsideRange={date => date.isBefore(new Date(), "month")}
                />
            
            <div
                style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    marginTop: 24
                }}
            >
                <Button
                    style={{ width: 85, height: 44 }}
                    buttonText="Guardar"
                    loading={loading}
                    disabled={selectedDate ? false : true}
                    onClick={handleSaveDate}
                />
            </div>
        </MainModal>
    );
};

export default SelectDateModal;
